var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70843 11.6483C3.41537 11.3553 3.41534 10.8802 3.70836 10.5872C4.00137 10.2941 4.47648 10.2942 4.76953 10.5872L7.73967 13.5574L7.74022 2.30991C7.7402 1.89874 8.07349 1.56545 8.48466 1.56548C8.89583 1.56551 9.22917 1.89885 9.2292 2.31002L9.22865 13.5575L12.1983 10.5878C12.4913 10.2948 12.9664 10.2948 13.2595 10.5879C13.5525 10.8809 13.5526 11.356 13.2596 11.6491L9.04816 15.8604C9.0347 15.8747 9.02095 15.8884 9.00692 15.9016C8.9537 15.9533 8.8947 15.9955 8.83205 16.0283C8.72548 16.0855 8.60845 16.1159 8.48433 16.1159C8.27769 16.1159 8.09072 16.0317 7.95582 15.8957L3.70843 11.6483Z",
    fill: "#6A7383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e14a8d409d56e0a1348a42be2acf243b.svg";
export { ForwardRef as ReactComponent };